import type { VideoProvider } from "../hooks/useResources";

export const CAL_BOOK_20MIN_URL: string = "https://cal.com/chat-with-jake/20min";

// Google Calendar appointment page for booking an ongoing coaching session
// (distinct from the onboarding call — see ztc.onboarding.book-call-url on the
// backend). Drives the "Book coaching session" button in the dashboard
// concierge panel.
export const BOOK_COACHING_URL: string =
  "https://calendar.app.google/HFTGbpEpXb2eNUwJ6";

// Customer support inbox, shown wherever we invite customers to reach out
// (e.g. "want to use a different AI provider? email us").
export const SUPPORT_EMAIL: string = "support@zerotoclaw.ai";

// Telegram BotFather deep link, where customers create their own bot in the
// guided Telegram setup flow. t.me opens the Telegram app (or web) directly.
export const BOTFATHER_URL: string = "https://t.me/BotFather";

// The onboarding walkthrough shown on the locked-instance dashboard while our
// team finishes setup. It guides customers to set up integrations (email /
// calendar / messaging) self-serve before their call.
//
// "Onboarding to the ZeroToClaw platform", https://youtu.be/aCYP6KWLY_U.
// To swap it, set the provider and id: the `v=` param (or youtu.be slug) for
// YouTube, the slug after loom.com/share/ for Loom. Null shows a "coming soon"
// placeholder in its place.
//
// Unlike admin-managed resources this one isn't pasted as a URL by a human at
// runtime, so it carries the already-resolved id rather than duplicating the
// backend's URL allowlist here.
export const PRE_ONBOARDING_VIDEO: { provider: VideoProvider; videoId: string } | null = {
  provider: "youtube",
  videoId: "aCYP6KWLY_U",
};

// Where the customer turns on "Enable device code authorization for Codex".
// Deliberately the plain settings entry point rather than a guessed deep link
// to the Security tab: a fragment that stops working lands them on a blank
// pane with no idea where to go, whereas this always opens settings and the
// written breadcrumb in the modal covers the last two steps.
export const CHATGPT_SETTINGS_URL: string = "https://chatgpt.com/#settings";

// The exact toggle, spelled as ChatGPT spells it — customers scan for this
// string, and OpenAI's own error message quotes it verbatim.
export const CHATGPT_DEVICE_CODE_SETTING: string =
  "Enable device code authorization for Codex";
